<template>
  <el-tooltip class="item" effect="dark" content="搜索" placement="top-start">
    <el-button style="order:9" size="small" icon="el-icon-search" circle @click="openSearchBox"></el-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'search-form-show',
  props: {
    searchBoxFlag: {
      type: Boolean,
      default: false,
    },
    reduceHeight:{
      type:Number,
      default:0
    },
    reduceShowHeight:{
      type:Number,
      default:0
    },
    option: {},
    refOption: {},
    removeHeight: '',
  },
  data() {
    return {
      //  searchBoxFlag:true
    };
  },
  methods: {
    openSearchBox() {
      this.searchBoxFlag = !this.searchBoxFlag;
      this.$emit('update:searchBoxFlag', this.searchBoxFlag);
      this.$nextTick(() => {
        // console.log(this.$refs.crud.$refs.table.$el.offsetTop);
        if (this.searchBoxFlag) {
          this.$set(this.option, 'height', this.bodyHeight - this.removeHeight - 279  -this.reduceShowHeight -this.reduceHeight );
          //   console.log(this.option.height);
        } else {
          this.$set(this.option, 'height', this.bodyHeight - 279 -this.reduceHeight);
          //   console.log(this.option.height);
        }
        // console.log(this.refOption)
        this.refOption.getTableHeight();
      });
    },
  },
};
</script>

<style>
</style>
